export function activatePrelaunchTarget() {
  const target = document.getElementById("prelaunch-target");
  const form = document.getElementById("prelaunch-form");
  if (target && form) {
    target.addEventListener(
      "click",
      () => {
        form.classList.remove("hidden");
      },
      false,
    );
  }
}
